import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function EstabelecimentosPrivilegios({ user , permissions, setPermissions }) {
  return (
    <>
            <Header header={'Estabelecimentos'} />
            <InfoFieldGroup
                fields={
                    [
                        {
                            // label: '',
                            value:
                                <ButtonSwitch
                                    // width={true}
                                    adminId={user._id}
                                    permission={'VerEstabelecimentosLicenciados'}
                                    permissions={permissions}
                                    setPermission={setPermissions}
                                    title={'Ver Estabelecimentos Licenciados'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: '',
                            value:
                                <ButtonSwitch
                                    // width={true}
                                    adminId={user._id}
                                    permission={'CategoriasEstabelecimentos'}
                                    permissions={permissions}
                                    setPermission={setPermissions}
                                    title={'Categorias de Estabelecimentos'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: '',
                            value:
                                <ButtonSwitch
                                    // width={true}
                                    adminId={user._id}
                                    permission={'CadastrarEstabelecimentos'}
                                    permissions={permissions}
                                    setPermission={setPermissions}
                                    title={'Cadastrar Estabelecimentos'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                    ]} />
    </>
  )
}
